import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getSessionListSvc, excelReportSvc, uploadManualTtExcelSvc } from "./scheduleTimetableSvc";

const ScheduleHeader2 = ({ sessionId, setSessionId,
    schKey, setSchKey, scheduleTimetableA, getData,
    scheduleTimetableB, scheduleTimetableC, openAvailibilityReport }) => {
    const [lstAcademicSession, setLstAcademicSession] = useState([]);

    const [sessionWidth, setSessionWidth] = useState(0);

    useEffect(() => {
        getSessionList();
    }, [schKey]);

    useEffect(() => {
        if (lstAcademicSession && lstAcademicSession.length > 0) {
            // console.log("lstAcademicSession ", lstAcademicSession);
            // Calculate the width of each session based on the total number of regular sessions
            const regularSessions = lstAcademicSession.filter(session => session.sessionType === "Regular").length;
            const newSessionWidth = 100 / regularSessions;
            // console.log("New session width calculated, Total Regular Sessions", regularSessions, ", newSessionWidth: ", newSessionWidth);
            setSessionWidth(newSessionWidth);
        }
    }, [lstAcademicSession]);

    const getSessionList = () => {
        // console.log("getSessionList called");
        getSessionListSvc(sessionListResponse);
    };

    const sessionListResponse = (data) => {
        // console.log("sessionListResponse called, data", data);
        if (data.status === "Success") {
            setLstAcademicSession(data.lstAcademicSchedule);
            if (data.lstAcademicSchedule.length > 0) {
                // Select the first 'Regular' session if none is selected
                const firstRegularSession = data.lstAcademicSchedule.find(
                    (schedule) => schedule.sessionType === "Regular"
                );
                if (firstRegularSession && !sessionId) {
                    setSessionId(firstRegularSession.academicScheduleId);
                }
            }
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
    };

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to the login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to the login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleSessionClick = (pScheduleId) => {
        // console.log("Session clicked, academicScheduleId", pScheduleId);
        setSessionId(pScheduleId);
    };

    const triggerUploadExcel = () => {
        document.getElementById("excelUpload").click();
    }
    const uploadExcel = (event) => {
        // setLoader('block');
        if (!event.target.files) {
            // setLoader('none');
            return;
        }

        var files = event.target.files; //FileList object

        files = files[0];
        var formData = new FormData();
        formData.append("manualTT", files);
        uploadManualTtExcelSvc(formData, cbUploadManualTtExcelUpload);

    }
    function cbUploadManualTtExcelUpload(data) {
        if (data.status === "Success") {
            toast.success(data.message);
            // $('#btn_showerror').trigger('click');
        }
        else if (data.status === "Failure") {
            toast.error(data.message);
            if (data.hasOwnProperty("errors") && data.errors.length !== 0) {
                // setFlgSliderType(20);
                // setErrorList(data.errors);
            }
        } else {

            if (data.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (data.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
        // setLoader('none')
    }

    return (
        <div className="col-lg-11 col-md-11 col-sm-11 col-xs-11 col-centered padding-remove">
            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 padding-remove">
                {/* <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 padding-remove"> */}
                {lstAcademicSession && lstAcademicSession.length > 0 && (
                    <div className="col-xs-12 padding-remove scheduleParentWrap">
                        <div className="scheduleWrap col-xs-12 padding-remove">
                            {lstAcademicSession.map((schedule, index) =>
                                schedule.sessionType === "Regular" && (
                                    <div
                                        key={index}
                                        style={{
                                            minHeight: "65px",
                                            // width: schedule.percentage,
                                            width: sessionWidth + "%",
                                            // width: (sessionWidth ? sessionWidth : schedule.percentage) + "%",
                                            minWidth: `calc(${schedule.percentage}% - 40px)`,
                                            padding: "5px 10px",
                                            border: schedule.academicScheduleId === sessionId ? "2px solid blue" : "1px solid #ccc", // Highlight selected session
                                            backgroundColor: schedule.academicScheduleId === sessionId ? "#f0f8ff" : "transparent", // Optional background
                                        }}
                                        className={"scheduleRegular"}
                                        title={`${schedule.fromDt} to ${schedule.toDt}`}
                                        onClick={() => handleSessionClick(schedule.academicScheduleId)}
                                    >
                                        <div>{schedule.label + " " + schedule.percentage + "%"}</div>
                                        <div>{schedule.dispFromDt + " - " + schedule.dispToDt}</div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 pull-right right-padding-remove" style={{ paddingLeft: 20 }}>
                {/* <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 "> */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    {/* give gap between buttons */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" style={{ display: "flex", gap: "16px" }}>
                        <button
                            type="button"
                            style={{ marginTop: 5 }}
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                var r = window.confirm("Are you sure, It will regenerate the timetable");
                                if (r) {
                                    scheduleTimetableC();
                                }
                            }}
                        >
                            Schedule
                        </button>

                        <input key={new Date().getTime()} type="file" id="excelUpload" className="hidden" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => uploadExcel(e)} />
                        {/* <span
                            className="glyphicon glyphicon-upload"
                            title="Manual Schedule"
                            onClick={(e) => {
                                e.stopPropagation();
                                triggerUploadExcel();
                            }}
                            style={{ top: 5, fontSize:30 }}></span> */}

                        <button
                            type="button"
                            style={{ marginTop: 5 }}
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                getData();
                            }}
                        >
                            Workload Report
                        </button>
                        {/* <span
                            onClick={() => openAvailibilityReport()}
                            title="View allocation status"
                            style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "15px" }}
                        >
                            Status
                        </span> */}
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                        Please select session to generate the timetable.
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">

                    </div>
                    {/* <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                        <button
                            type="button"
                            style={{ marginTop: 5 }}
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                scheduleTimetableB();
                            }}
                        >
                            Schedule Type B
                        </button>
                    </div> */}
                    {/* <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                        <button
                            type="button"
                            style={{ marginTop: 5 }}
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                scheduleTimetableC();
                            }}
                        >
                            Schedule C
                        </button>
                    </div> */}
                    {/* <div className="col-md-4 col-sm-4 col-xs-4 padding-remove" >
                        <span
                            onClick={() => openAvailibilityReport()}
                            title="View allocation status"
                            style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px"}}
                        >
                            Status
                        </span>
                    </div> */}
                </div>
            </div>
        </div >
    );
};

export default ScheduleHeader2;
